import React, { useState, useEffect, useRef } from 'react'
import { useDispatch } from 'react-redux'

import { EnrolState } from 'enum'
import { useWindowSize } from 'hooks/react.hooks'
import { mobileWidth } from 'enum/responsive-width.enum'
import * as fromActions from 'store/actions/externalCoursesEnrolled.action'
import { useTranslationRankmi } from 'helpers/translations.helper'
import { ContentContainer } from 'components/ui/content-container/ContentContainer'
import Table from './components/table'
import { prefixTranslation } from './common'

const Index: React.FC = () => {
  let bounceId: any
  const dispatch = useDispatch()
  const [searchText, setSearchText] = useState('')
  const [page, setPage] = useState(1)
  const [sort, setSort] = useState({})
  const [perPage, setPerPage] = useState(50)
  const [fastFilters, setFastFilters] = useState<EnrolState | null>(null)
  const [, setOnDesktop] = useState(true)
  const windowsSize = useWindowSize()
  const tRelative = useTranslationRankmi({
    prefix: prefixTranslation,
  })

  const searchTextRef = useRef<any>()

  useEffect(() => {
    if (windowsSize.width)
      setOnDesktop(windowsSize.width < mobileWidth ? false : true)
  }, [windowsSize])

  useEffect(() => {
    searchTextRef.current = searchText
    const timer = setTimeout(() => {
      dispatch(
        fromActions.Actions.getList({
          params: {
            page,
            searchText,
            sort,
            state: fastFilters,
            perPage,
          },
        })
      )
    }, 1000)
    return () => clearTimeout(timer)
  }, [page, sort, searchText, perPage, fastFilters, dispatch])

  const handleSearch = (value: string) => {
    if (bounceId) {
      clearTimeout(bounceId)
    }
    bounceId = setTimeout(() => {
      setSearchText(value.trim())
    }, 1000)
  }

  return (
    <ContentContainer title={tRelative('subTitle')}>
      <Table
        setSearch={handleSearch}
        setPage={setPage}
        setSort={setSort}
        setPerPage={setPerPage}
        setFastFilters={setFastFilters}
      />
    </ContentContainer>
  )
}

export default Index
